import '.a9{flex:1 1 0;}.ssr-plugin'
import '.hp{border-radius:var(--border-radius-image);}.ssr-plugin'
import '.j2{background-color:var(--palette-steady-stone);}.ssr-plugin'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { Image } from '@app/components/core/image/Image'

export type LandingContentImageColumnProps = {
  imageSrc?: string
  imageAlt?: string
}

const LandingContentImageColumn = ({
  imageSrc,
  imageAlt = '',
}: LandingContentImageColumnProps) => {
  const isMobile = useMediaQuery()

  const frameHeight = isMobile ? '21rem' : '31rem'

  return imageSrc ? (
    <div className="a9 hp"
      style={{
        height: frameHeight,}}
    >
      <Image
        src={imageSrc}
        alt={imageAlt}
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  ) : (
    <div className="a9 hp j2"
      style={{
        minHeight: isMobile ? '20.5rem' : '30.5rem',}}
    />
  )
}

export default LandingContentImageColumn
